module.exports = __webpack_public_path__ + "img/big.83087a38.jpg";